import { CurrencyOptions } from '../../../../contexts/CurrencyContext';
import { getDefaultFilterOptions } from '../default';

const CHAIN = {
  title: 'Chain',
  type: 'checkbox',
  labels: ['Ethereum', 'Avalanche'],
};

export function getLikedFilterOptions(currencyOptions: CurrencyOptions) {
  return [...getDefaultFilterOptions(currencyOptions), CHAIN];
}
